import React, { useState } from 'react';

const FAVORITE_CONTACTS = [
  'Fav Contact 1',
  'Fav Contact 2',
  'Fav Contact 3',
  'Fav Contact 4',
  'Fav Contact 5',
];

const VolunteersSidebar = () => {
  const [contactsOpen, setContactsOpen] = useState(true);

  const toggleContacts = (event) => {
    event.preventDefault();
    setContactsOpen((open) => !open);
  };

  return (
    <div className="card h-100">
      <div className="card-body">
        <h6 className="text-uppercase text-muted small mb-3">Volunteers</h6>
        <ul className="nav flex-column nav-pills">
          <li className="nav-item">
            <a
              className="nav-link d-flex justify-content-between align-items-center active bg-light border rounded"
              href="#"
              onClick={toggleContacts}
            >
              <span>Contacts</span>
              <span className="small text-muted">
                {contactsOpen ? '▾' : '▸'}
              </span>
            </a>
            {contactsOpen && (
              <div className="mt-2 ms-3">
                <ul className="list-unstyled mb-1">
                  {FAVORITE_CONTACTS.map((name) => (
                    <li
                      key={name}
                      className="d-flex justify-content-between align-items-center py-1"
                    >
                      <a href="#" className="text-decoration-none text-secondary small">
                        {name}
                      </a>
                      <span className="text-warning small" aria-hidden="true">
                        {'\u2605'}
                      </span>
                    </li>
                  ))}
                </ul>
                <button type="button" className="btn btn-link btn-sm p-0 small">
                  Show all 12 favorites
                </button>
              </div>
            )}
          </li>
          <li className="nav-item mt-2">
            <a className="nav-link" href="#">
              Segments
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default VolunteersSidebar;
